import { fetchIngredients } from "Root/checkout/redux/slices/checkoutUserCartSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
const useCheckoutReccomendations = () => {
    const dispatch = useDispatch();
    const ingredients = useSelector((state) => state.checkoutUserCart.ingredients);
    const userCart = useSelector((state) => state.checkoutUserCart.userCart).filter((item) => item.item_category !== "accessory");
    const getIngredient = (key) => {
        return ingredients.find((item) => item.product_key === key) || {};
    };
    const fetchData = () => {
        dispatch(fetchIngredients(false));
    };
    const isDifferentIngredients = userCart.length !== ingredients.length;
    useEffect(() => {
        if ((userCart.length > 0 && ingredients.length === 0) || isDifferentIngredients) {
            fetchData();
        }
    }, [userCart.length, ingredients.length]);
    return {
        getIngredient,
        userCart,
    };
};
export default useCheckoutReccomendations;
